// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ResStatus_Phone_abstract } from './../../abstract/SagaBase/Objects/ResStatus_Phone_abstract';
export class ResStatus_Phone extends ResStatus_Phone_abstract {}
